export enum PermissionGrant {

  NONE = 'NONE',
  R = 'R',
  RW = 'RW',
  RWD = 'RWD',
}
